import React from 'react'
import './Notification.css'
import { useCikContext } from '../../Context/CentralIndustrisContaxtProvider'
import {MdOutlineCancel} from 'react-icons/md'
import {BiCheckCircle} from 'react-icons/bi'

function Notification() {
  const { notiStatus  , notiContent , notiError } = useCikContext()  
  return (
    <div className={notiStatus ? "noti-baar active" : "noti-baar"}  >
         <div className='noti-inner-bar' >
            <h4>
                 {
                    notiError ? 
                    <MdOutlineCancel />
                    :
                    <BiCheckCircle />
                 }
                 <span>{notiContent}</span>
            </h4>
         </div>  
    </div>
  )
}

export default Notification